export const CommentEndpoints = {
  getCommentImage: (publicationId: number, commentId: number) =>
    `/rest/v2/news/${publicationId}/comments/${commentId}/secureSnapshot`,
  getPublicCommentImage: (publicationId: number, commentId: number) =>
    `/rest/v2/news/${publicationId}/comments/${commentId}/snapshot`,
  getCommentAudio: (commentId: number) => `/v1/communities/comments/${commentId}/media`,
  getCommentDocument: (publicationId: number, commentId: number) =>
    `/rest/v2/news/${publicationId}/comments/${commentId}/downloadSecure`,
  getRepliesComments: (id: number, commentId: number) =>
    `rest/v3/news/${id}/comments/${commentId}/replies`
}
